import React, { useState, useEffect } from 'react';
import { Alert, Button, CheckInDoc2Icon, PlusIcon, RefreshIcon, Searchbar, Select, Toolbar, EditIcon } from 'react-unity';
import { authenticatedUser } from '../../../authentication/authModule';
import SubscriptionRequest from '../../../models/entities/SubscriptionRequest';
import { UserRole } from '../../../models/enums/UserRole';
import CSVGeneratorButton from '../../common/CSVGeneratorButton';
import CheckboxFilter, { CheckboxOption } from '../../common/tables/CheckboxFilter';
import Filter from '../../common/tables/Filter';
import ExportColumns from './SubscriptionsHomeExport';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import './SubscriptionsHome.css';
import ResourceTabs from '../../common/ResourceTabs';

type SubscriptionsFilters = {
	searchGeneral: string;
	status: CheckboxOption[];
	l3Organization: CheckboxOption[];
	type: CheckboxOption[];
	azureState: CheckboxOption[];
	dateRangeFrom: Date;
	dateRangeTo: Date;
	searchTenantName: CheckboxOption[];
	showResources: string;
	orderBy: string;
};

interface SubscriptionsHomeFiltersProps {
	setFilteredSubscriptions: any;
	areMySubsLoading: boolean;
	areAllSubsLoading: boolean;
	filteredSubscriptions: SubscriptionRequest[];
	retreiveSubscriptions: any;
	allSubscriptions: SubscriptionRequest[];
	attestationSubscriptions: SubscriptionRequest[];
	setEditMultiple: any;
	editMultiple: boolean;
	setModalVisibleEditMode: any;
	checkBoxState: number;
}

const SubscriptionsHomeFilters = ({
	setFilteredSubscriptions,
	areMySubsLoading,
	areAllSubsLoading,
	filteredSubscriptions,
	retreiveSubscriptions,
	allSubscriptions,
	attestationSubscriptions,
	setEditMultiple,
	editMultiple,
	setModalVisibleEditMode,
	checkBoxState,
}: SubscriptionsHomeFiltersProps) => {
	const navigate = useNavigate();
	const resourceTabs = [];
	resourceTabs.push({
		item1 : `My Subscriptions`,
		item2: null,
	});
	authenticatedUser.isInRole(UserRole.OrgAdmins) && resourceTabs.push({
		item1: `Admin Subscriptions`,
		item2: null
	});
	resourceTabs.push({
		item1: `All Subscriptions`,
		item2: null
	});
	resourceTabs.push({
		item1: `Attestation`,
		item2: null
	});
	const defaultFilters = {
		searchGeneral: '',
		searchTenantName: [
			{ label: 'onmschina', value: 'onmschina', checked: true },
			{ label: 'Other', value: 'Other', checked: true },
		],
		status: [
			{ label: 'Submitted', value: 'Submitted', checked: true },
			{ label: 'Approved', value: 'Approved', checked: true },
			{ label: 'Rejected', value: 'Rejected', checked: true },
			{ label: 'Deleted', value: 'Deleted', checked: false },
			{ label: 'Error', value: 'Error', checked: false },
		],
		l3Organization: [
			{ label: 'APPS', value: 'APPS', checked: true },
			{ label: 'CES', value: 'CES', checked: true },
			{ label: 'CORP', value: 'CORP', checked: true },
			{ label: 'DATA SC&AN', value: 'DSA', checked: true },
			{ label: 'EDSA', value: 'EDSA', checked: true },
			{ label: 'EGUL IT', value: 'EGULIT', checked: true },
			{ label: 'FOUND INF', value: 'FI', checked: true },
			{ label: 'FLCIT', value: 'FLCIT', checked: true },
			{ label: 'IT OPS EXCELL', value: 'ITOE', checked: true },
			{ label: 'IT/OT SERVICES PROGRAM', value: 'ITOT', checked: true },
			{ label: 'IT RISK MGMT', value: 'ITRM', checked: true },
			{ label: 'IT STRATEGY', value: 'ITS', checked: true },
			{ label: 'PROJ', value: 'PROJ', checked: true },
			{ label: 'SCCOT', value: 'SCCOT', checked: true },
			{ label: 'UIT', value: 'UIT', checked: true },
			{ label: '(No organization)', value: '(No organization)', checked: true },
		],
		type: [
			{ label: 'Connected', value: 'Connected', checked: true },
			{ label: 'Disconnected', value: 'Disconnected', checked: true },
		],
		azureState: [
			{ label: 'Enabled', value: 'Enabled', checked: true },
			{ label: 'Disabled', value: 'Disabled', checked: false },
			{ label: 'Deleted', value: 'Deleted', checked: false },
			{ label: 'Not Available', value: 'Not Available', checked: false },
		],
		dateRangeFrom: new Date('January 01, 2000 23:15:30'),
		dateRangeTo: new Date(),
		showResources: 'My Subscriptions',
		orderBy: 'newest',
	} as SubscriptionsFilters;

	const [isOrgAdmin] = useState<boolean>(authenticatedUser.isInRole(UserRole.OrgAdmins));

	const filterSubscriptions = () => {
		let filtered = [];
		let sourceSubscriptions = allSubscriptions;

		if (filter.filters.showResources === 'Attestation') {
			sourceSubscriptions = attestationSubscriptions || [];
		}

		const filterCallback = (sub: SubscriptionRequest) => {
			return (
				filter.filterCheckBox('status', sub.workflowInstance.currentWorkflowInstanceState.workflowState.name) &&
				filter.filterCheckBox('l3Organization', sub.organization.L3?.shortName ?? '(No organization)') &&
				filter.filterCheckBox('type', sub.isConnected ? 'Connected' : 'Disconnected') && 
				(filter.filterSearchText('searchGeneral', sub.createdSubscriptionName) ||
					filter.filterSearchText('searchGeneral', sub.createdSubscriptionId) ||
					filter.filterSearchText('searchGeneral', sub.owner.displayName) ||
					filter.filterSearchText('searchGeneral', sub.custodian.displayName) ||
					filter.filterSearchText('searchGeneral',sub.subscriptionUsedFor) || 
					filter.filterSearchText('searchGeneral', sub.custodianTwo?.displayName ?? '')||
					(sub.cartaIds.length > 0 && filter.filterSearchTextInArray('searchGeneral', sub.cartaIds, 'cartaAppId'))
				) &&
				filter.filterCheckBox('searchTenantName', sub.tenant.name) &&
				filter.filterCheckBox('azureState', sub.azureState) &&
				filter.filterDateRange('dateRangeFrom', 'dateRangeTo', sub.workflowInstance.createdDate)  

				);
			
		}; 

		filtered = sourceSubscriptions.filter(filterCallback);


		if (filter.filters.showResources == 'My Subscriptions') {
			filtered = filtered.filter(
				(sub: SubscriptionRequest) =>
					(sub.owner.id === authenticatedUser.userId ||
					sub.custodian.id === authenticatedUser.userId ||
					sub.custodianTwo?.id === authenticatedUser.userId)
			);
		}

		if (filter.filters.showResources == 'Admin Subscriptions') {
			filtered = filtered.filter(
				(sub: SubscriptionRequest) =>
					isOrgAdmin && authenticatedUser.myL3Orgs.includes(sub.organization?.L3?.displayName)
			);
		}

		const nullState = 'Not Available';
		filtered.sort((a, b) => {
			const aa = a.azureState ? a.azureState : nullState;
			const bb = b.azureState ? b.azureState : nullState;
			if (aa === bb) {
				return filter.filters.orderBy === 'newest'
					? moment(b.workflowInstance.createdDate).valueOf() -
							moment(a.workflowInstance.createdDate).valueOf()
					: moment(a.workflowInstance.createdDate).valueOf() -
							moment(b.workflowInstance.createdDate).valueOf();
			}
			if (aa === 'Enabled') return -1;
			if (bb === 'Enabled') return 1;
			if (aa > bb) return 1;
			if (aa < bb) return -1;
			return 0;
		});

		setFilteredSubscriptions(filtered);
	};

	useEffect(() => {
		filter.updateFilterFunction(filterSubscriptions);
	}, [allSubscriptions, attestationSubscriptions]);

	useEffect(() => {
		filter.filter();
	}, []);

	const [filter] = useState<Filter<SubscriptionsFilters>>(new Filter(filterSubscriptions, defaultFilters));

	const handleRefresh = () => {
		setEditMultiple(false);
		filter.updateFilter('My Subscriptions', 'showResources');
		retreiveSubscriptions(true);
	};

	const clearSearchbar = (e) => {
		e.preventDefault();
		filter.updateFilter('', 'searchGeneral');
	};

	return (
		<>
			{filter && (
				<>
					<ResourceTabs
						allResources={resourceTabs}
						filter={filter}
						disabled={areMySubsLoading || areAllSubsLoading}
					/>
					<Toolbar id="toggle-toolbar">
						<Toolbar.Item className="searchbar-width">
							<Searchbar
								condensed
								buttonProps={{ onClick: clearSearchbar}}
								inputProps={{
									value: filter.filters.searchGeneral,
									onChange: (e) => filter.handleSearchTextChange(e, 'searchGeneral'),
									placeholder: 'Search (i.e. Subscription Name, Intended Usage, Type, etc.)',
								}}
							/>
						</Toolbar.Item>
						<Toolbar.Item right>
							<Button.Group>
							{(authenticatedUser.isInRole(UserRole.SubscriptionAdmin) ||
									authenticatedUser.isInRole(UserRole.DisconnectedSubscriptionRequestor) ||
									authenticatedUser.isInRole(UserRole.ConnectedSubscriptionRequestor)) && (
									<Button
										variant="primary"
										size="small"
										onClick={() => {
											navigate('/subscriptions/new');
										}}
									>
										<PlusIcon size="small" />
										<span>Request Subscription</span>
									</Button>
								)}
								{authenticatedUser.isInRole(UserRole.SubscriptionAdmin) && (
									<Button
										variant="primary"
										size="small"
										onClick={() => {
											navigate('/subscriptions/import');
										}}
									>
										<CheckInDoc2Icon size="small" />
										<span>Import Subscription</span>
									</Button>
								)}
								<CSVGeneratorButton data={filteredSubscriptions} columns={ExportColumns} />
								<Button variant="secondary" size="small" onClick={handleRefresh}>
									<RefreshIcon size="small" />
									<span> Refresh</span>
								</Button>
								<Button
										disabled={!authenticatedUser.isInRole(UserRole.SubscriptionAdmin) && !(filter.filters.showResources == 'My Subscriptions' || filter.filters.showResources == 'Admin Subscriptions') && !areMySubsLoading}
										variant="secondary"
										size="small"
										onClick={() => {
											setEditMultiple(!editMultiple);											
										}}
									>
										<EditIcon className="edit-icon" size="small" />
										{!editMultiple ? <span>Edit Multiple</span> : <span>Cancel Edition</span>}
								</Button>
								{editMultiple && 
									<Button
											disabled={checkBoxState == 0}
											variant="secondary"
											size="small"
											onClick={() => {
												setModalVisibleEditMode(true);								
											}}
										>
											<EditIcon className="edit-icon" size="small" />
											<span>Edit</span>
									</Button>
								}
							</Button.Group>
						</Toolbar.Item>
					</Toolbar>

					<Toolbar>
						<Toolbar.Item>
							<CheckboxFilter
								label="Type"
								onChange={(event) => filter.handleCheckboxChange(event, 'type')}
								options={filter.filters.type}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Status"
								buttonProps={{ size: 'small' }}
								onChange={(event) => filter.handleCheckboxChange(event, 'status')}
								options={filter.filters.status}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Organization"
								onChange={(event) => filter.handleCheckboxChange(event, 'l3Organization')}
								options={filter.filters.l3Organization}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Tenant Name"
								onChange={(event) => filter.handleCheckboxChange(event, 'searchTenantName')}
								options={filter.filters.searchTenantName}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<CheckboxFilter
								label="Azure State"
								onChange={(event) => filter.handleCheckboxChange(event, 'azureState')}
								options={filter.filters.azureState}
							/>
						</Toolbar.Item>
						<Toolbar.Item>
							<span
								className="clear-filters"
								onClick={() =>
									filter.updateFilters({ ...defaultFilters, showResources: filter.filters.showResources })
								}
							>
								Clear filters
							</span>
						</Toolbar.Item>
						<Toolbar.Item right>
							<Button.Group>
								<p className="sort-by-p">Sort by</p>
								<Select
									style={{ marginBottom: -10, cursor: 'pointer' }}
									value={filter.filters.orderBy}
									onChange={(e) => filter.handleSearchTextChange(e, 'orderBy')}
								>
									<option value="newest">Newest</option>
									<option value="oldest">Oldest</option>
								</Select>
							</Button.Group>
						</Toolbar.Item>
					</Toolbar>
				</>
			)}
		</>
	);
};

export default SubscriptionsHomeFilters;
